import {Injectable} from '@angular/core';
import {QueryEntity} from '@datorama/akita';
import {ProductParameterState, Store} from './store';

@Injectable({ providedIn: 'root' })
export class ProductParameterQuery extends QueryEntity<ProductParameterState> {

  constructor(protected store: Store) {
    super(store);
  }

}
